import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import useMutation from 'hooks/useMutation'

import Button from 'components/atoms/Button'
import Spinner from 'components/atoms/Spinner'

export default function AppDownload() {
  const { t } = useTranslation()
  const isDownloadingRef = useRef<boolean>(false)

  const { trigger } = useMutation('/v1/files/app')

  const shadow = 'shadow-[0_0_10px_0_#00000026]'
  const layout =
    'bg-white flex flex-col justify-between w-[476px] h-[332px] p-[60px] rounded-[20px] text-center'

  const handleDownloadApk = () => {
    if (!isDownloadingRef.current) {
      isDownloadingRef.current = true
      trigger(
        {
          method: 'get',
          data: null
        },
        {
          onSuccess: (data) => {
            const url = data
            const link = document.createElement('a')
            link.href = url
            link.download = 'digitori360-app.apk'
            link.click()
            isDownloadingRef.current = false
          },
          onError: () => {
            isDownloadingRef.current = false
          }
        }
      )
    }
  }

  return (
    <>
      {isDownloadingRef.current && <Spinner />}
      <div className="flex h-full">
        <div className={`m-auto ${layout} ${shadow}`}>
          <div className="flex justify-center flex-col mb-6">
            <p className="text-[1.25rem] leading-[28.96px] text-center font-bold text-[#3163B7] mb-0 h-[30px]">
              {t('translation.androidAppDownloadTitle')}
            </p>
            <hr className="w-20 border-[#3163B7] border-0 border-b border-solid" />
          </div>
          <div className="mb-[30px] text-left leading-[26px] text-[#021120] whitespace-pre-line">
            {t('translation.androidAppDownloadGuide')}
          </div>
          <Button
            block
            sizing="h-[60px]"
            className="bg-[#3163B7]"
            onClick={handleDownloadApk}
          >
            {t('translation.androidAppDownload')}
          </Button>
        </div>
      </div>
    </>
  )
}
